import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import CalculatorLineDisplayCard from './calculator_line_display_card';
import ConfigFile from '../../datasets/config_file';
import CalculatorText from '../for-parents/text/calculator_text';
import CreditCardExerciseDataset from './Datasets/credit_card_exercise_dataset';
import {Tooltip} from "@mui/material";

class CreditCardCalculatorModal extends Component {
  constructor(props) {
    super(props);
    this.state={
         entryTab: [],
         calcComplete: false,
         displayFullInstructions: true,
         exercise1: true,
         exerciseDisplay: false,
         rerender: false,
         defaultClass:  "font-weight-bold",
    };    
    this.setTooltipText();
    this.initializeAmounts();
  }

  setTooltipText(){
      this.initialAmtTooltip =  "This is the amount that is due on the credit card from prior months.";
      this.paymentOptionParmTooltip =  "Determine how the credit card balance " +
            "will be paid. If 'Pay Monthly Amount' is selected, then the Monthly Pay Amount is required.";
      this.monthlyPayAmtParmTooltip =  "This indicates the amount that you " +
            "intend to pay each month that will be applied to the credit card balance.  It is only valid if " +
            "the Payment Option is 'Pay Monthly Amount'.";
      this.monthlyChgAmtParmTooltip = "How much money will be added to " +
            "the credit card each month (new charges)?.";
      this.nbrYearsParmTooltip = "How many years should these factors be applied?";
  }

  initializeAmounts(){
    this.infoMessage = "";
    this.exerciseText = "";
    this.initialAmt = 0;
   
    this.creditCardLineArr = [];
    this.creditCardIntRate = +ConfigFile.unlockedFeatures.creditCardInterest;
    this.minPaymentPercent = +ConfigFile.unlockedFeatures.creditCardMinimumPayPct;
    this.creditCardIntRateDisplay = (+this.creditCardIntRate * 100).toFixed(0);
    this.minPaymentPercentDisplay = (+this.minPaymentPercent * 100).toFixed(0);
    const creditCardTextObj = CalculatorText.find(elem => elem.type === "CreditCard");
    this.creditCardText = creditCardTextObj.reportText;
    this.creditCardParmArr = [];
    this.initialAmtClass = this.state.defaultClass;
    this.monthlyPayOptionClass = this.state.defaultClass;
    this.monthlyPayAmtClass = this.state.defaultClass;
    this.monthlyChgAmtClass = this.state.defaultClass;
    this.nbrYearsClass = this.state.defaultClass;
    this.resetExerciseButtons();
  }
  
  calculateCreditCardAmounts(entryName){
      this.initialAmtError = "";
      this.exerciseText = "";
      this.errorFound = false;
      this.errorMsg = "";
      if (entryName === "Entered"){
            this.conclusionText = "";
            this.getFormFields();
            this.editInputParameters();
            if (this.dataValid === true){
                this.calcValuesEntered();
            }
      }else{
            this.initialAmt = 10000;
            this.calcExerciseValues(entryName);
      }
  }

  getFormFields(){
      this.initialAmt = document.getElementById("initialAmt").value;
      this.paymentOption = document.getElementById("paymentOption").value;
      this.monthlyPayAmt = document.getElementById("monthlyPayAmt").value;
      this.monthlyChargeAmt = document.getElementById("monthlyChargeAmt").value;
      this.nbrYears = document.getElementById("nbrYears").value;
      
  }
  
  editInputParameters(){
      this.dataValid = true;
      this.initialAmtClass = this.state.defaultClass;
      this.monthlyPayOptionClass = this.state.defaultClass;
      this.monthlyPayAmtClass = this.state.defaultClass;
      this.monthlyChgAmtClass = this.state.defaultClass;
      this.nbrYearsClass = this.state.defaultClass;
      this.errorMsg = "";
      if (!this.initialAmt){
          this.dataValid = false;
          this.initialAmtClass += " text-danger";
      }
      if (this.paymentOption === "none"){
          this.dataValid = false;
          this.monthlyPayOptionClass += " text-danger";
      }
      if (this.paymentOption === "monthlyAmt" && !this.monthlyPayAmt){
          this.dataValid = false;
          this.monthlyPayAmtClass += " text-danger";
      }
      if (!this.monthlyChargeAmt){
          this.dataValid = false;
          this.monthlyChgAmtClass += " text-danger";
      }
      if (!this.nbrYears){
          this.dataValid = false;
          this.nbrYearsClass += " text-danger";
      }
      if (this.dataValid === false){
          this.errorMsg = "Field values are required and cannot be blank."
      }else{
          if (isNaN(+this.initialAmt)){
              this.dataValid = false;
              this.initialAmtClass += " text-danger";
          }
          if (isNaN(+this.monthlyPayAmt)){
              this.dataValid = false;
              this.monthlyPayAmtClass += " text-danger";
          }
          if (isNaN(+this.monthlyChargeAmt)){
              this.dataValid = false;
              this.monthlyChgAmtClass += " text-danger";
          }
          if (isNaN(+this.nbrYears)){
              this.dataValid = false;
              this.nbrYearsClass += " text-danger"
          }
          if (this.dataValid === false){
              this.errorMsg = "Field(s) must be numeric and no special characters (commas, dollar sign, etc.).";
          }
      }
      if (this.dataValid === true){
          if (this.paymentOption !== "monthlyAmt" && this.monthlyPayAmt){
              this.dataValid = false;
              this.monthlyPayAmtClass += " text-danger";
              this.errorMsg = "Monthly Pay amount is not valid unless Payment Option is 'Pay Monthly Amount'";
          }
      }
      
  }
  
  
  calcExerciseValues(exerciseName){
      switch (exerciseName){
          case "PaymentOption":
            this.paymentOptionDisabled = true;
            break;
          case "PayBalance":
             this.payBalanceButtonDisabled = true;
             break;
          default:
             break;
      }
      this.processExerciseValues(exerciseName);
  }

  processExerciseValues(exerciseName){
      this.creditCardParmArr = [];
      this.resetExerciseButtons();
      const exerciseObj = 
        CreditCardExerciseDataset.find(elem => elem.exerciseName === exerciseName);
      this.exerciseText = exerciseObj.text;
      this.conclusionText = exerciseObj.conclusion;
      const creditCardParmArr = exerciseObj.parametersArr;
      for (let i=0; i<creditCardParmArr.length; i++){
          this.paymentOption = creditCardParmArr[i].paymentOption;
          this.monthlyChargeAmt = creditCardParmArr[i].monthlyChargeAmt;
          if (this.paymentOption === "full" || this.paymentOption === "min"){
              // no monthly pay amount is required
          }else{
               this.monthlyPayAmt = creditCardParmArr[i].monthlyPayAmt;
          }
          this.nbrYears = creditCardParmArr[i].nbrYears;
          this.calcValuesEntered();
      }
  }
  
  calcValuesEntered(){   
    if (this.errorFound === false){
        this.calculateLineAmts();
    }
    if (this.errorFound === false){
        this.creditCardLineArr.push(this.creditCardObj);
        if (this.creditCardLineArr.length > 5){
            this.creditCardLineArr.splice(0,1);
            this.infoMessage = 
              "Max of 5 calculations, the first entry has rolled off.  Click on the 'Clear/Reset' " +
                " button if you wish to clear all entries and start again."
        }else{
          this.infoMessage = "";
        }
    }
    this.setState({calcComplete: true});
  }

  calculateLineAmts(){
      let nbrIterations = 0;
      let outOfPocket = 0;
      let totalInterest = 0;
      let currentBalance = +this.initialAmt;
      let monthlyPayAmt = 0;
      const totalMonths = this.nbrYears * 12;
      if (this.paymentOption === "full"){
          currentBalance = 0;
          outOfPocket = (+this.initialAmt + (+this.monthlyChargeAmt * totalMonths)).toFixed(2);
      }else{
          const monthlyIntRate = (this.creditCardIntRate / 12).toFixed(6);
          while (nbrIterations < totalMonths){
              monthlyPayAmt = this.monthlyPayAmt;
              currentBalance = +currentBalance + +this.monthlyChargeAmt; 
              let minPayAmt = (+currentBalance * +this.minPaymentPercent).toFixed(2);
              if (this.paymentOption === "min"){
                  monthlyPayAmt = minPayAmt;
              }else{
                  if (minPayAmt > monthlyPayAmt ){
                     monthlyPayAmt = minPayAmt;
                  }
              }
              if (monthlyPayAmt > currentBalance){
                      monthlyPayAmt = currentBalance;
              }
              currentBalance = +currentBalance - +monthlyPayAmt;
              outOfPocket += +monthlyPayAmt;
              let monthlyIntAmt = (currentBalance * monthlyIntRate).toFixed(2);
              totalInterest = +totalInterest + +monthlyIntAmt;
              currentBalance = +currentBalance + +monthlyIntAmt;
              nbrIterations += 1;
          }
      }
      const endingBalance = currentBalance;
      monthlyPayAmt = null;
      if (this.paymentOption === "min" || this.paymentOption === "full"){
          monthlyPayAmt = (outOfPocket / totalMonths).toFixed(2);
      }else{
          monthlyPayAmt = +this.monthlyPayAmt;
      }
      const nbrYearsLit = this.nbrYears + " Yrs";
      const totalAmtNewCharges = (+this.monthlyChargeAmt * +totalMonths) + +this.initialAmt;
      this.creditCardObj={beginCreditCardBalance: this.initialAmt, monthlyPayAmt: monthlyPayAmt, 
        payOption: this.paymentOption, monthlyChargeAmt: this.monthlyChargeAmt, nbrYears: nbrYearsLit, 
        outOfPocket: outOfPocket, totalNewChargeAmt: totalAmtNewCharges, totalInterest: totalInterest, 
        endCreditCardBalance: endingBalance}  ;
  }

  resetExerciseButtons(){
    this.paymentOptionDisabled = false;
    this.payBalanceButtonDisabled = false;
  }
  
  onClear(){
    this.creditCardLineArr = [];
    this.infoMessage = "";
    this.initialAmt = 0;
    this.exerciseText = "";
    document.getElementById("initialAmt").value = "";
    this.setState({rerender: !this.state.rerender});
  }
 
  render() { 
    
    this.calculatorLines = this.creditCardLineArr.map((creditCardInfo, index) =>
      <CalculatorLineDisplayCard calcLineInfo={creditCardInfo}  key={index} index={index}
         />
          );
  return <>
    <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="xl" scrollable="true"
         dialogClassName="extraCredit-modal-size" animation={false}>
      <Modal.Header className="backgroundTopBottom" closeButton>
        <Modal.Title>Credit Card Calculator</Modal.Title> 
      </Modal.Header>
      <Modal.Body>
          
          <div className="mx-2 mt-1">
            <p>{this.creditCardText}</p>
            <p>Here are some other factors that impact the calculations.  These factors are based on amounts
               that are typically applied by banks that administer credit cards. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>Minimum Payment Percent:</b>&nbsp;&nbsp; {this.minPaymentPercentDisplay}%&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>Credit Card Interest:</b>&nbsp;&nbsp; {this.creditCardIntRateDisplay}%
            </p>
        </div>  
        {this.state.exercise1  ?
            <div className="mx-2 mb-2">{this.creditCardExercise1Text}</div>
        :
            null
        }
       
        <div className="container">
            <div className="row justify-content-center align-items-center">

                  <div className="col-sm-2 p-2 ml-3">
                      <Tooltip title={this.initialAmtTooltip} arrow >
                        <label htmlFor="monthlyPayAmount" className={this.initialAmtClass}
                            style={{ whiteSpace: 'nowrap' }} >
                              Initial Amount:
                        </label>
                      </Tooltip>
                      <input type="text" className="form-control" id="initialAmt" name="initialAmt"
                        style={{ maxWidth: '180px' }} />
                  </div>
                            
                  <div className="col-sm-3 p-2 ml-4 mt-3">
                    <div className="form-group">
                      <Tooltip title={this.paymentOptionParmTooltip} arrow>
                        <label className={this.monthlyPayOptionClass} htmlFor="paymentOption">Payment Option:</label>
                      </Tooltip>
                      <select 
                        className="form-control" id="paymentOption" name="paymentOption">
                            <option value="none">No Payment Option Selected</option>
                            <option value="full">Pay Full Balance Each Month</option>
                            <option value="min">Pay Minimum Amt Each Month</option>
                            <option value="monthlyAmt">Pay Monthly Amt Each Month</option>
                      </select>
                    </div>
                  </div>
            
                  <div className="col-sm-2 p-2 ml-3">
                      <Tooltip title={this.monthlyPayAmtParmTooltip} arrow >
                        <label htmlFor="monthlyPayAmount" className={this.monthlyPayAmtClass}
                            style={{ whiteSpace: 'nowrap' }} >
                              Amt Paid Monthly:
                        </label>
                      </Tooltip>
                      <input type="text" className="form-control" id="monthlyPayAmt" name="monthlyPayAmt"
                        style={{ maxWidth: '180px' }} />
                  </div>

                  <div className="col-sm-2 p-2 ml-3">
                      <Tooltip title={this.monthlyChgAmtParmTooltip} arrow >
                        <label htmlFor="monthlyChargeAmount" className={this.monthlyChgAmtClass}
                            style={{ whiteSpace: 'nowrap' }} >
                              Month Chg Amt:
                        </label>
                      </Tooltip>
                      <input type="text" className="form-control" id="monthlyChargeAmt" name="monthlyChargeAmt"
                        style={{ maxWidth: '180px' }} />
                  </div>
                      
                  <div className="col-sm-1 p-2 ml-3">
                      <Tooltip title={this.nbrYearsParmTooltip} arrow >
                        <label htmlFor="nbrYears" className={this.nbrYearsClass}
                            style={{ whiteSpace: 'nowrap' }} >
                              Nbr of Years:
                        </label>
                      </Tooltip>
                      <input type="text" className="form-control" id="nbrYears" name="nbrYears"
                        style={{ maxWidth: '180px' }} />
                  </div>
              </div>
          </div>
          <table className="table table-hover">
            <thead>
              <tr className="thead-light">
                <th></th>
                <th className="py-0 text-center" scope="col">
                    <Tooltip title="Amt of money initially outstanding on the credit card." arrow >
                        <span className="text-dark"> Beginning Balance</span>
                    </Tooltip>
                </th>
                <th className="py-0 text-center" scope="col">
                    <Tooltip title="This is determined based on the 'Payment Option' field." arrow >
                        <span className="text-dark">Amt Paid Each Month</span>
                    </Tooltip>      
                </th>
                <th className="py-0 text-center" scope="col">
                    <Tooltip title="This is equal to the 'Avg Amt Charged Each Month' factor." arrow >
                        <span className="text-dark">Monthly Charge Amt</span>
                    </Tooltip>
                </th>
                <th className="py-0 text-center" scope="col">
                    <Tooltip title="This is equal to the 'Number of Years' factor." arrow >
                        <span className="text-dark">Amt of Time</span>
                    </Tooltip>
                </th>
                <th className="py-0 text-center" scope="col">
                  <Tooltip title="The total amount added to the card balance 
                      for the specified number of years plus the initial credit card balance amount." arrow>
                          <span className="text-dark">Total Amt Charged</span>
                  </Tooltip>
                </th>
                <th className="py-0 text-center" scope="col">
                  <Tooltip title={this.state.toolTipMonthlyChgAmt} arrow>
                      <span className="text-dark">Total Interest Charged</span>
                  </Tooltip>
                </th>
                <th className="py-0 text-center" scope="col">
                  <Tooltip title="The total that you have actually paid 'out-of-pocket'." arrow >
                      <span className="text-dark">Total Amount Paid</span>
                  </Tooltip>
                </th>
                <th className="py-0 text-center" scope="col">
                  <Tooltip title="The total amount that is owed on the credit card 
                      after the factors are applied." arrow >
                        <span className="text-dark">Ending Balance</span>
                  </Tooltip>
                </th>
              </tr>
            </thead>
            <tbody>
                {this.calculatorLines}
            </tbody>
        </table>
        {this.props.exerciseButtons   ?
            <span>
                <div className="mt-2">
                      Learn more about the credit card factors:  Enter your own values (above) and click the Calculate button 
                        ...OR... click on one of the buttons below.  When you are done, click the Close button.
                      <div>
                        <Button className="mt-2"
                            disabled={this.paymentOptionButtonDisabled} variant="info"  
                            onClick={() => this.calculateCreditCardAmounts("PaymentOption")}>
                                Payment Option
                        </Button>
                        <Button className="mt-2 ml-2"
                            disabled={this.payBalanceButtonDisabled} variant="info"  
                            onClick={() => this.calculateCreditCardAmounts("PayBalance")}>
                                Pay Off Existing Balance
                        </Button>
                      </div>
                  </div>
                  <div className="text-left">
                      {this.exerciseText}
                </div>
                {this.exerciseText !== "" ?
                    <div><b>Conclusion:</b>&nbsp;{this.conclusionText}</div>
                  :
                    null
                }
            </span>
        :
            null
        }

        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom">
          <p className="text-right">{this.infoMessage}</p>
          <p className="text-danger">{this.errorMsg}</p>
          <div>
              <Button className="ml-2" variant="primary"  onClick={() => this.props.onClose()}>
                  Close
              </Button>
              <Button className="ml-2" variant="primary"   onClick={() => this.onClear()}>
                  Clear/Reset
              </Button>
              <Button className="ml-2" variant="primary"  onClick={() => this.calculateCreditCardAmounts("Entered")}>
                  Calculate
              </Button>
          </div>
         
        </Modal.Footer>
      </Modal>

  

      
    </>
  }

 
}
export default CreditCardCalculatorModal;